import React, { useState, useEffect } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ExcelMerger from './components/ExcelMerger';
import SheetSplitter from './components/SheetSplitter';
import ExcelToJSONCSV from './components/ExcelToJSONCSV';
import TextCaseStandardizer from './components/TextCaseStandardizer';
import ExcelDeduplication from './components/ExcelDeduplication';
import SuggestTool from './components/SuggestTool';
import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';

function App() {
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = () => {
    setExpanded(false);
  };

  // Create a RouteTracker component to handle route changes
  function RouteTracker() {
    const location = useLocation();
    
    useEffect(() => {
      // Track page view when route changes
      if (window.usermaven) {
        window.usermaven('page_view', {
          url: window.location.href,
          path: location.pathname,
          title: document.title
        });
      }
    }, [location]);

    return null;
  }

  return (
    <HelmetProvider>
      <Router>
        <RouteTracker />
        <div className="App d-flex flex-column min-vh-100">
          <style>
            {`
              .hover-card {
                transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
              }
              .hover-card:hover {
                transform: translateY(-5px);
                box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
              }
              .hero-section {
                background: linear-gradient(135deg, rgba(40, 167, 69, 0.05) 0%, rgba(255, 255, 255, 0.1) 100%);
              }
              .gradient-text {
                background: linear-gradient(120deg, #198754, #28a745);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
              }
              .features-section {
                background: linear-gradient(135deg, rgba(40, 167, 69, 0.1) 0%, rgba(25, 135, 84, 0.15) 100%);
              }
              .features-section .card {
                background: rgba(255, 255, 255, 0.95);
              }
            `}
          </style>
          <Navbar expand="lg" className="custom-navbar" expanded={expanded} onToggle={setExpanded}>
            <Container>
              <Navbar.Brand as={Link} to="/" className="me-4" onClick={handleNavClick}>
                <img
                  src={process.env.PUBLIC_URL + '/images/toolbox.svg'}
                  alt="Excel Toolbox"
                  className="d-inline-block me-2"
                  width="24"
                  height="24"
                />
                Excel Toolbox
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto gap-3">
                  <Nav.Link as={Link} to="/excel-workbook-combiner" onClick={handleNavClick}>Excel Workbook Combiner</Nav.Link>
                  <Nav.Link as={Link} to="/excel-sheet-splitter" onClick={handleNavClick}>Excel Sheet Splitter</Nav.Link>
                  <Nav.Link as={Link} to="/excel-to-json-csv" onClick={handleNavClick}>Excel to JSON/CSV</Nav.Link>
                  <Nav.Link as={Link} to="/text-case-standardizer" onClick={handleNavClick}>Text Case Standardizer</Nav.Link>
                  <Nav.Link as={Link} to="/excel-deduplication" onClick={handleNavClick}>Excel Deduplication</Nav.Link>
                  <Nav.Link as={Link} to="/suggest-tool" onClick={handleNavClick}>Suggest Tool</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>

          <div className="flex-grow-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/excel-workbook-combiner" element={<Container><ExcelMerger /></Container>} />
              <Route path="/excel-sheet-splitter" element={<Container><SheetSplitter /></Container>} />
              <Route path="/excel-to-json-csv" element={<Container><ExcelToJSONCSV /></Container>} />
              <Route path="/text-case-standardizer" element={<Container><TextCaseStandardizer /></Container>} />
              <Route path="/excel-deduplication" element={<Container><ExcelDeduplication /></Container>} />
              <Route path="/suggest-tool" element={<Container><SuggestTool /></Container>} />
              <Route path="/privacy-policy" element={<Container><PrivacyPolicy /></Container>} />
              <Route path="/terms-of-use" element={<Container><TermsOfUse /></Container>} />
            </Routes>
          </div>

          <footer className="bg-light py-4 mt-auto">
            <Container>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                <div className="text-muted mb-3 mb-md-0">
                  <p className="mb-1">{'\u00A9'}{new Date().getFullYear()} Excel Toolbox. All rights reserved.</p>
                  <p className="small mb-0">Excel is a registered trademark of Microsoft Corporation.</p>
                </div>
                <div className="d-flex gap-4">
                  <Link to="/privacy-policy" className="text-muted text-decoration-none">Privacy Policy</Link>
                  <Link to="/terms-of-use" className="text-muted text-decoration-none">Terms of Use</Link>
                </div>
              </div>
            </Container>
          </footer>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
